/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { PartnerService } from 'src/app/pages/partners/services/partner.service';
import { SettingsDashboardService } from '../../../services/settingsDashboard.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { IListByFilterParceiros, IPartner } from 'src/app/pages/partners/models/partner.interface';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ICompany } from 'src/app/pages/companies/models/company.interface';

@Component({
  selector: 'app-add-new-theme',
  templateUrl: './add-new-theme.component.html',
  styleUrls: ['./add-new-theme.component.scss']
})
export class AddNewThemeComponent {
  ERoleAdminString = ERoleAdminString;
  formAberto = false;
  partners: IPartner[] = [];
  companies: ICompany[] = [];
  public isPartnerSelected = false;

  formTheme = new UntypedFormGroup({
    partnerId: new UntypedFormControl('', [Validators.required]),
    logoUrl: new UntypedFormControl('', [Validators.pattern(/^https?:\/\/.+/)]),
    logoPrintUrl: new UntypedFormControl('', [Validators.pattern(/^https?:\/\/.+/)]),
    themeName: new UntypedFormControl('', [Validators.required]),
    primaryColor: new UntypedFormControl('#ee4574'),
    secondaryColor: new UntypedFormControl('#164f62'),
    accentColor: new UntypedFormControl('#2b99be'),
    companyIds: new UntypedFormControl([])
  });
  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  constructor(
    private readonly partnerService: PartnerService,
    private readonly toastService: ToastService,
    private readonly settingsDashboardService: SettingsDashboardService,
    private readonly sessionService: SessionService,
  ) { }

  public ngOnInit(): void {
    this.loadPartners()
    this.formTheme.get('companyIds')?.disable();
  }

  public sendPartnerTheme(): void {
    if (this.formTheme.invalid) {
      this.toastService.toast("Preencha todos os campos obrigatórios antes de salvar.", EMessageType.Error);
      this.formTheme.markAllAsTouched();
      return;
    }
    if (this.formTheme.valid) {
      const theme = this.formTheme.getRawValue();
      const dados = {
        partnerId: theme.partnerId,
        themeName: theme.themeName,
        theme: {
          logoUrl: theme.logoUrl || undefined,
          logoPrintUrl: theme.logoPrintUrl || undefined,
          primaryColor: theme.primaryColor,
          secondaryColor: theme.secondaryColor,
          accentColor: theme.accentColor,
        },
        companyIds: theme.companyIds || []
      };

      this.settingsDashboardService.createTheme(dados).subscribe((resposta) => {
        if (resposta.messages && resposta.messages.length > 0) {
          this.toastService.toast("Tema criado com sucesso!");
        }

        if (resposta.isSucceed) {
          this.formAberto = false;
          this.formTheme.reset();
        }
      });
    }
  }

  loadPartners(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const accountRole = this.sessionService.getSession().accountRole;

    const filtros: IListByFilterParceiros = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    this.partnerService.listarTodosParceiros(filtros).subscribe((resposta) => {
      this.partners = resposta.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(resposta.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = resposta.count!;
    });
  }

  onPartnerChange(partnerId: string): void {
    if (partnerId) {
      this.isPartnerSelected = true;
      this.formTheme.get('companyIds')?.enable();
      this.listCompanies(partnerId);
    }
  }

  public listCompanies(partnerId: string): void {
    this.partnerService.listCompaniesByPartnerId(partnerId).subscribe((response) => {
      this.companies = response.data;
    });
  }
}
